// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"207":"b5087add","361":"58e268fb","453":"2c6e4f7c","563":"c366efe7","751":"732bf5a3"}[chunkId] + ".chunk.js";
};